<template>
  <div :id="figId + '-wrapper'" class="fixed-grid min-width" :key="figId" :class="[figId]">
    <figure :id="figId">
      <svg viewBox="0 0 1440 552" class="c-1--1">
        <!-- <style>
          .B {
            fill: #fff;
          }
          .C {
            font-family: Inter-Regular, Inter;
          }
          .D {
            font-size: 14px;
          }
          .E {
            font-family: Inter-Medium, Inter;
          }
          .F {
            font-size: 16px;
          }
        </style>-->
        <defs>
          <filter x="-10%" y="-10%" width="120%" height="120%" id="ali-symbol-shadow">
            <feOffset in="SourceAlpha" result="shadowOffsetOuter" />
            <feGaussianBlur stdDeviation="10" in="shadowOffsetOuter" result="shadowBlurOuter" />
            <feColorMatrix
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              type="matrix"
              in="shadowBlurOuter"
              result="shadowMatrixOuter"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="#2d2d2d" d="M0 0h1440v552H0z" />
          <path fill="#0f0f0f" d="M0 456h732v96H0z" />
          <path fill="#1a1a1a" d="M732 456h475v96H732z" />
          <path fill="#242424" d="M1207 456h233v96h-233z" />
          <text class="ali-symbols-text-body">
            <tspan x="219" y="520">Layer Styles</tspan>
          </text>
          <text class="ali-symbols-text-title">
            <tspan x="219" y="499">Layer</tspan>
          </text>
          <text class="ali-symbols-text-body">
            <tspan x="390" y="520">Text Styles</tspan>
          </text>
          <text class="ali-symbols-text-title">
            <tspan x="390" y="499">Layer</tspan>
          </text>
          <text class="ali-symbols-text-body">
            <tspan x="744" y="520">Reusable Symbols</tspan>
          </text>
          <text class="ali-symbols-text-title">
            <tspan x="744" y="499">Element</tspan>
          </text>
          <text class="ali-symbols-text-body">
            <tspan x="1245" y="520">Artboards</tspan>
          </text>
          <text class="ali-symbols-text-title">
            <tspan x="1245" y="499">Screen</tspan>
          </text>
          <image
            x="219"
            width="411"
            height="456"
            filter="url(#ali-symbol-shadow)"
            href="@/assets/work/alibaba/content/ui-symbol/color-layer.png"
          />
          <image
            x="390"
            width="499"
            height="456"
            filter="url(#ali-symbol-shadow)"
            href="@/assets/work/alibaba/content/ui-symbol/text-layer.png"
          />
          <image
            x="732"
            width="475"
            height="456"
            filter="url(#ali-symbol-shadow)"
            href="@/assets/work/alibaba/content/ui-symbol/component-element.png"
          />
          <image
            x="1245"
            y="24"
            width="512"
            height="384"
            filter="url(#ali-symbol-shadow)"
            href="@/assets/work/alibaba/content/key-screens/window.png"
          />
        </g>
      </svg>
    </figure>
  </div>
</template>

<style lang="scss">
@import '@/styles/base.scss';

.ali-symbols {
  @extend .margin2-b;
}

.ali-symbols-text-body {
  @extend .text-title;
  font-weight: 500 !important;
  letter-spacing: -0.69;
  fill: $text-dark;
}
.ali-symbols-text-title {
  @extend .text-title;
  @extend .large;
  letter-spacing: -0.789;
  fill: $text-dark;
}
</style>

<script>
// import anime from 'animejs'

export default {
  name: 'ali-symbols',
  data() {
    return {
      svgLib: {
        // palette: require('@/assets/work/alibaba/content/color-palette.svg')
      },
      figId: 'ali-symbols'
    }
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {}
}
</script>
